import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap'; // Assuming react-bootstrap for modals
import DataTable from 'react-data-table-component';
import { authorizedRequest } from '../../api/authorizedRequest';
import Swal from 'sweetalert2';

interface ApplicationHistory {
    id: number;
    fromStatus: string;
    toStatus: string;
    remarks: string;
    actionBy: string;
    actionDate: string;
}

interface ApplicationHistoryModalProps {
    show: boolean;
    onClose: () => void;
    applicationId: string;
}

export const ApplicationHistoryModal: React.FC<ApplicationHistoryModalProps> = ({
    show,
    onClose,
    applicationId,
}) => {
    const [history, setHistory] = useState<ApplicationHistory[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (show && applicationId) {
            fetchHistory();
        }
    }, [show, applicationId]);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const response = await authorizedRequest({ 
                url: `/JobApplication/${applicationId}/history`,
                method: 'GET',
            });
            setHistory(response.data);
        } catch (error) {
            console.error('Error fetching history:', error);
            Swal.fire('Error', 'Failed to fetch application history.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            name: 'From Status',
            selector: (row: ApplicationHistory) => row.fromStatus,
            sortable: false,
        },
        {
            name: 'To Status',
            selector: (row: ApplicationHistory) => row.toStatus,
            sortable: false,
        },
        {
            name: 'Remarks',
            selector: (row: ApplicationHistory) => row.remarks,
            sortable: false,
        },
        {
            name: 'Action By',
            selector: (row: ApplicationHistory) => row.actionBy,
            sortable: false,
        },
        {
            name: 'Action Date',
            selector: (row: ApplicationHistory) => new Date(row.actionDate).toLocaleString(),
            sortable: false,
        },
    ];

    return (
        <Modal show={show} onHide={onClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Application History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DataTable
                    columns={columns}
                    data={history}
                    progressPending={loading}
                    noHeader
                    pagination
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
